import React, { useEffect, useState } from 'react';
import AppLayout from '../../../../components/layout/AppLayout';
import { message } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { TLesson } from '../../../../models/courses/lesson';
import { useCourseApi } from '../../../../api/courses/courses';
import { LanguageId } from '../../../../components/IDE/ide/core/types';
import IDEPhaserAdmin from '../../../../components/IDEPhaser/IDEPhaserAdmin';


interface IDEPhaserProps {
    language: LanguageId;
}

const LessonIDEPhaser: React.FC<IDEPhaserProps> = ({ language }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { getLessonDetailsById } = useCourseApi();

    const lesson: TLesson = location.state?.lesson;
    const teacherMode: boolean = location.state?.teacherMode || false;
    const [editingLesson, setEditingLesson] = useState<TLesson | undefined>(lesson);
    const [loading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        if (lesson) {
            getLessonDetailsById(lesson.id)
                .then((results) => {
                    const lessonData = results;
                    setEditingLesson(lessonData.data);
                })
                .catch((err) => {
                    message.error(err.response.data ?? err.message);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
        // eslint-disable-next-line
    }, [lesson]);



    const handleBackNavigation = () => {
        navigate(-1);
    };

    return (
        <AppLayout 
            title={lesson.name} 
            loading={loading}
            onBackNavigation={handleBackNavigation}
            showBackButton={true}
        >
            <IDEPhaserAdmin editingLesson={editingLesson} language={language} teacherMode={teacherMode} />
        </AppLayout>
    );
};

export default LessonIDEPhaser;
